export default __webpack_public_path__ + "static/media/promo_00.014addf5.jpg";